import type { EditorState } from '@atlaskit/editor-prosemirror/state';

/**
 * Keys that typically end a word in prose. Narrow filter so we do not schedule
 * idle work on every keypress.
 */
export function isWordTerminatorKey(event: KeyboardEvent): boolean {
	if (event.metaKey || event.ctrlKey || event.altKey) {
		return false;
	}
	if (event.key === 'Enter') {
		return true;
	}
	if (event.key.length === 1) {
		return /[\s.,;:!?)\]}"'»«/\\]/u.test(event.key);
	}
	return false;
}

/**
 * After a terminator was typed, the word that was just completed is the last
 * token before trailing separators in the current text block (cursor position).
 */
export function getCompletedWord(state: EditorState): string | null {
	const { $from } = state.selection;
	if (!$from.parent.isTextblock || $from.parentOffset === 0) {
		return null;
	}

	const textBefore = $from.parent.textBetween(0, $from.parentOffset, undefined, '\ufffc');
	const withoutTrailingSeparators = textBefore.replace(/[\s\p{P}]+$/u, '');
	if (!withoutTrailingSeparators) {
		return null;
	}

	const words = withoutTrailingSeparators.split(/[\s\p{P}]+/u);
	const last = words[words.length - 1];
	if (!last || !/^[\p{L}\p{N}_]+$/u.test(last)) {
		return null;
	}

	return last;
}

/**
 * Whether the word is a keyword trigger (case-insensitive). Accepts a set or array of
 * lowercased keywords (as produced by the trigger-keyword getters).
 */

export function isKeywordTrigger(word: string, keywordSet: readonly string[]): boolean {
	return keywordSet.includes(word.toLowerCase());
}
